module.exports = __webpack_public_path__ + "static/media/flower-bouquet.ae699467.svg";